import { Component, h } from 'preact';

import Contest from './Contest';
import PymChild from './PymChild';
import { INDIVIDUAL_RESULT_URL } from '../endpoints';

class RaceApp extends Component {
  constructor() {
    super();

    this.state = { contest: null };
  }

  componentDidMount() {
    const contestSlug = this.props.contest;
    fetch(`${INDIVIDUAL_RESULT_URL(contestSlug)}`)
      .then(res => res.json())
      .then(contest => this.setState({ contest }));
  }

  render({}, { contest }) {
    return (
      <PymChild className="race-embed">
        {contest && (
          <Contest
            contest={contest}
            year={2018}
            shouldIncludeMap
            includeContestCaptionDetail
          />
        )}
      </PymChild>
    );
  }
}

export default RaceApp;



// WEBPACK FOOTER //
// ./componentsV2/RaceApp.js